import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ConfirmationDialogComponent,
  ConfirmDialogData,
} from '@lockton-apps/shared/ui/lui';
import { DeleteContactRequirementsDialogContentComponent } from './delete-contact-requirements/delete-contact-requirements-dialog-content.component';

@Injectable({
  providedIn: 'root',
})
export class ContactsDialogService {
  constructor(private dialog: MatDialog) {}

  showDeleteContactRequirements() {
    return this.dialog
      .open<ConfirmationDialogComponent, ConfirmDialogData, boolean>(
        ConfirmationDialogComponent,
        {
          data: {
            title: $localize`Unable to delete contact`,
            content: DeleteContactRequirementsDialogContentComponent,
            contentData: {
              inputs: {},
            },
            confirmButtonText: $localize`Re-assign contact`,
            cancelButtonText: $localize`Cancel`,
            dismissible: true,
          },
        }
      )
      .afterClosed();
  }
}
